import { render } from "./SteplessSliderChoice.vue?vue&type=template&id=355191bd&scoped=true&ts=true"
import script from "./SteplessSliderChoice.vue?vue&type=script&lang=ts"
export * from "./SteplessSliderChoice.vue?vue&type=script&lang=ts"

import _style_0 from "./SteplessSliderChoice.vue?vue&type=style&index=0&id=355191bd&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-355191bd"]])

export default __exports__